"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Minimum SDK versions that support Snack features
const features = {
    MULTIPLE_FILES: '21.0.0',
    PROJECT_DEPENDENCIES: '25.0.0',
    TYPESCRIPT: '31.0.0',
    UNIMODULE_IMPORTS: '33.0.0',
    POSTMESSAGE_TRANSPORT: '35.0.0',
    VERSIONED_SNACKAGER: '37.0.0',
};
exports.default = features;
//# sourceMappingURL=features.js.map